import { Box, Stack, Typography, styled, useTheme } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import { CheckCircleIcon } from '@lingoda/ui/icons/lingodaIcons';

interface Props {
    isTeamsRegistration: boolean;
}

export const Content = ({ isTeamsRegistration }: Props) => {
    const theme = useTheme();

    return (
        <ContainerStyled>
            <TypographyStyled variant="h1">
                {trans('create-account-to-unlock-lingoda', {}, 'student-registration')}
            </TypographyStyled>
            <Stack
                component="ul"
                spacing={2}
                sx={{ margin: 0, padding: 0, display: { xs: 'none', sm: 'flex' } }}
            >
                <ListItemStyled>
                    <CheckCircleIcon size={24} color={theme.colors.brand.neon} weight="fill" />
                    <span>
                        {isTeamsRegistration
                            ? trans('access-our-platform', {}, 'student-registration')
                            : trans('book-your-classes', {}, 'student-registration')}
                    </span>
                </ListItemStyled>
                <ListItemStyled>
                    <CheckCircleIcon size={24} color={theme.colors.brand.neon} weight="fill" />
                    <span>{trans('test-your-knowledge', {}, 'student-registration')}</span>
                </ListItemStyled>
                <ListItemStyled>
                    <CheckCircleIcon size={24} color={theme.colors.brand.neon} weight="fill" />
                    <span>{trans('download-learning-materials', {}, 'student-registration')}</span>
                </ListItemStyled>
            </Stack>
        </ContainerStyled>
    );
};

const ContainerStyled = styled(Box)(({ theme }) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        gap: theme.spacing(5),
        alignSelf: 'stretch',
        flex: '1 1 50%',
        minWidth: 0,
        paddingRight: theme.spacing(6),
        [theme.breakpoints.down('md')]: {
            padding: 0,
            alignItems: 'center',
            textAlign: 'center',
            margin: '0 auto',
            maxWidth: 540,
            gap: theme.spacing(3),
        },
        [theme.breakpoints.down('sm')]: {
            alignItems: 'flex-start',
            textAlign: 'left',
            padding: theme.spacing(0, 5),
            marginBottom: theme.spacing(6),
        },
    };
});

const TypographyStyled = styled(Typography)(({ theme }) => {
    return {
        color: theme.palette.background.default,
    };
});

const ListItemStyled = styled('li')(({ theme }) => {
    return {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        color: theme.palette.background.default,
        ...theme.typography.h6,
        listStyle: 'none',
    };
});
